import { cn } from '@lib/utils';
import type { ReactNode } from 'react';

interface SectionContainerProps {
  children: ReactNode;
  className?: string;
}

// 패딩을 max-width 바깥에 두어야 콘텐츠 폭이 정확히 1260px가 됨
// (max-width와 패딩을 한 요소에 두면 콘텐츠가 1260-패딩으로 줄어듦)
export default function SectionContainer({
  children,
  className,
}: SectionContainerProps) {
  return (
    <div className="w-full md:px-8">
      <div className={cn('mx-auto w-full max-w-[1260px]', className)}>
        {children}
      </div>
    </div>
  );
}
